import initialState from './initialState'

// Types
const SET_CURRENT_QUESTION = 'question/SET_CURRENT_QUESTION'
const SET_CURRENT_ERROR = 'questions/SET_CURRENT_ERROR'
const ANSWER_QUESTION = 'questions/ANSWER_QUESTION'
const TOGGLE_LOADER = 'questions/TOGGLE_LOADER'
// Action Creators
export const setCurrentQuestion = (question, slideDirection) => ({
  type: SET_CURRENT_QUESTION,
  payload: { question, slideDirection }
})

export const setCurrentError = (error, slideDirection) => ({
  type: SET_CURRENT_ERROR,
  payload: { error, slideDirection }
})

export const answerQuestion = answer => ({
  type: ANSWER_QUESTION,
  payload: answer
})

export const toggleLoader = () => ({
  type: TOGGLE_LOADER
})

// Reducer
const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case SET_CURRENT_QUESTION:
    return {
      ...state,
      currentQuestion: payload.question,
      slideDirection: payload.slideDirection
    }
  case SET_CURRENT_ERROR:
    return {
      ...state,
      currentError: payload.error,
      slideDirection: payload.slideDirection
    }
  case ANSWER_QUESTION:
    return {
      ...state,
      [payload.key]: payload.value
    }
  case TOGGLE_LOADER:
    return {
      ...state,
      loading: !state.loading
    }
  default:
    return state
  }
}

export default reducer
